export const TYPE_CASE_SPA = 'SPA';
export const TYPE_CASE_LA = 'LA';


export const LAWYER_CASE_TYPES = [
  { text: TYPE_CASE_SPA, value: TYPE_CASE_SPA, name: TYPE_CASE_SPA },
  { text: TYPE_CASE_LA, value: TYPE_CASE_LA, name: TYPE_CASE_LA },
];

export const DEVELOPER_CANCELLED = 'DEVELOPER_CANCELLED';
export const DEVELOPER_CANCELLED_OPTION = { text: 'Developer Cancelled', value: DEVELOPER_CANCELLED, name: DEVELOPER_CANCELLED, color: 'status-danger' };

// SPA Tracker status
export const PENDING_APPOINTMENT = 'PENDING_APPOINTMENT';
export const SPA_SIGNED_PENDING = 'SPA_SIGNED_PENDING';
export const SPA_SIGNED = 'SPA_SIGNED';
export const SPA_RECEIVED = 'SPA_RECEIVED';
export const DEVELOPER_SIGNED = 'DEVELOPER_SIGNED';
export const LAWYER_COLLECTED = 'LAWYER_COLLECTED';
export const SOLD = 'SOLD';
export const DEVELOPER_RECEIVED = 'DEVELOPER_RECEIVED';

export const PENDING_APPOINTMENT_OPTION = { text: 'Pending Appointment', value: PENDING_APPOINTMENT, name: PENDING_APPOINTMENT, color: 'status-warning' };
export const SPA_SIGNED_PENDING_OPTION = { text: 'SPA Signed Pending', value: SPA_SIGNED_PENDING, name: SPA_SIGNED_PENDING, color: 'status-warning' };
export const SPA_SIGNED_OPTION = { text: 'SPA Signed', value: SPA_SIGNED, name: SPA_SIGNED, color: 'status-good' };
export const SPA_RECEIVED_OPTION = { text: 'SPA Received', value: SPA_RECEIVED, name: SPA_RECEIVED, color: 'status-good' };
export const DEVELOPER_SIGNED_OPTION = { text: 'Developer Signed', value: DEVELOPER_SIGNED, name: DEVELOPER_SIGNED, color: 'status-good' };
export const LAWYER_COLLECTED_OPTION = { text: 'Lawyer Collected', value: LAWYER_COLLECTED, name: LAWYER_COLLECTED, color: 'status-good' };
export const SOLD_OPTION = { text: 'SPA Stamped', value: SOLD, name: SOLD, color: 'status-good' };
export const DEVELOPER_RECEIVED_OPTION = { text: 'Developer Received', value: DEVELOPER_RECEIVED, name: DEVELOPER_RECEIVED, color: 'status-good' };

export const LAWYER_SPA_STATUSES = [
  PENDING_APPOINTMENT_OPTION,
  SPA_SIGNED_PENDING_OPTION,
  SPA_SIGNED_OPTION,
  SPA_RECEIVED_OPTION,
  DEVELOPER_SIGNED_OPTION,
  LAWYER_COLLECTED_OPTION,
  SOLD_OPTION,
  DEVELOPER_RECEIVED_OPTION,
  DEVELOPER_CANCELLED_OPTION,
];

export const LAWYER_SPA_STATUS_MILESTONES = [
  PENDING_APPOINTMENT_OPTION,
  SPA_SIGNED_OPTION,
  SPA_RECEIVED_OPTION,
  DEVELOPER_SIGNED_OPTION,
  LAWYER_COLLECTED_OPTION,
  SOLD_OPTION,
  DEVELOPER_RECEIVED_OPTION,
];

export const getLawyerSPACaseStatuses = (status = PENDING_APPOINTMENT, company, hasUpdateAccess) => {
  const statuses = [];
  const currentStatus = LAWYER_SPA_STATUSES.find(s => s.value === status);
  if (currentStatus) {
    statuses.push({ ...currentStatus, disabled: true });
  }
  const hasAccess = company && company.lawyerAllowBuLeadersUpdate && hasUpdateAccess;
  switch (status) {
    case PENDING_APPOINTMENT:
      if (hasAccess) statuses.push(SPA_SIGNED_OPTION);
      break;
    case SPA_SIGNED:
      if (hasAccess) statuses.push(PENDING_APPOINTMENT_OPTION);
      statuses.push(SPA_RECEIVED_OPTION);
      break;
    case SPA_RECEIVED:
      if (hasAccess) statuses.push(SPA_SIGNED_OPTION);
      statuses.push(DEVELOPER_SIGNED_OPTION);
      break;
    case DEVELOPER_SIGNED:
      if (hasAccess) statuses.push(SPA_RECEIVED_OPTION);
      statuses.push(LAWYER_COLLECTED_OPTION);
      break;
    case LAWYER_COLLECTED:
      if (hasAccess) statuses.push(DEVELOPER_SIGNED_OPTION);
      statuses.push(SOLD_OPTION);
      break;
    case SOLD:
      if (hasAccess) statuses.push(LAWYER_COLLECTED_OPTION);
      statuses.push(DEVELOPER_RECEIVED_OPTION);
      break;
    default:
      break;
  }

  if (status !== SOLD) {
    statuses.push(DEVELOPER_CANCELLED_OPTION);
  }

  return statuses;
};


// LA Tracker status
export const NEW = 'NEW';
export const LA_SIGNED_BY_BORROWER = 'LA_SIGNED_BY_BORROWER';
export const LA_SIGNED_BY_BANK = 'LA_SIGNED_BY_BANK';
export const LOU_SIGNED_ISSUED = 'LOU_SIGNED_ISSUED';
export const LA_STAMPED = 'LA_STAMPED';
export const ADVICE_BANK = 'ADVICE_BANK';
export const FIRST_DISBURSEMENT = 'FIRST_DISBURSEMENT';


export const NEW_OPTION = { text: 'New', value: NEW, name: NEW, color: 'status-info' };
export const LA_SIGNED_BY_BORROWER_OPTION = { text: 'LA Signed by Borrower', value: LA_SIGNED_BY_BORROWER, name: LA_SIGNED_BY_BORROWER, color: 'status-good' };
export const LA_SIGNED_BY_BANK_OPTION = { text: 'LA Signed by Bank', value: LA_SIGNED_BY_BANK, name: LA_SIGNED_BY_BANK, color: 'status-good' };
export const LOU_SIGNED_ISSUED_OPTION = { text: 'LOU Signed & Issued', value: LOU_SIGNED_ISSUED, name: LOU_SIGNED_ISSUED, color: 'status-good' };
export const LA_STAMPED_OPTION = { text: 'LA Stamped', value: LA_STAMPED, name: LA_STAMPED, color: 'status-good' };
export const ADVICE_BANK_OPTION = { text: 'Advice Bank for 1st Draw Down', value: ADVICE_BANK, name: ADVICE_BANK, color: 'status-danger' };
export const FIRST_DISBURSEMENT_OPTION = { text: '1st Disbursement', value: FIRST_DISBURSEMENT, name: FIRST_DISBURSEMENT, color: 'status-danger' };


export const LAWYER_LA_STATUSES = [
  NEW_OPTION,
  LA_SIGNED_BY_BORROWER_OPTION,
  LA_SIGNED_BY_BANK_OPTION,
  LOU_SIGNED_ISSUED_OPTION,
  LA_STAMPED_OPTION,
  ADVICE_BANK_OPTION,
  FIRST_DISBURSEMENT_OPTION,
  DEVELOPER_CANCELLED_OPTION,
];

export const LAWYER_LA_STATUS_MILESTONES = [
  NEW_OPTION,
  LA_SIGNED_BY_BORROWER_OPTION,
  LA_SIGNED_BY_BANK_OPTION,
  LOU_SIGNED_ISSUED_OPTION,
  LA_STAMPED_OPTION,
  ADVICE_BANK_OPTION,
  FIRST_DISBURSEMENT_OPTION,
];

export const getLawyerLACaseStatuses = (status = NEW, company, hasUpdateAccess) => {
  const statuses = [];
  const currentStatus = LAWYER_LA_STATUSES.find(s => s.value === status);
  if (currentStatus) {
    statuses.push({ ...currentStatus, disabled: true });
  }
  const hasAccess = company && company.lawyerAllowBuLeadersUpdate && hasUpdateAccess;
  if (hasAccess) {
    switch (status) {
      case NEW:
        statuses.push(LA_SIGNED_BY_BORROWER_OPTION);
        break;
      case LA_SIGNED_BY_BORROWER:
        statuses.push(NEW_OPTION);
        statuses.push(LA_SIGNED_BY_BANK_OPTION);
        break;
      case LA_SIGNED_BY_BANK:
        statuses.push(LA_SIGNED_BY_BORROWER_OPTION);
        statuses.push(LOU_SIGNED_ISSUED_OPTION);
        break;
      case LOU_SIGNED_ISSUED:
        statuses.push(LA_SIGNED_BY_BANK_OPTION);
        statuses.push(LA_STAMPED_OPTION);
        break;
      case LA_STAMPED:
        statuses.push(LOU_SIGNED_ISSUED_OPTION);
        statuses.push(ADVICE_BANK_OPTION);
        break;
      case ADVICE_BANK:
        statuses.push(LA_STAMPED_OPTION);
        statuses.push(FIRST_DISBURSEMENT_OPTION);
        break;
      default:
        break;
    }
  }
  if (status !== FIRST_DISBURSEMENT_OPTION) {
    statuses.push(DEVELOPER_CANCELLED_OPTION);
  }
  return statuses;
};

export const LAWYER_ALL_STATUSES = [
  PENDING_APPOINTMENT_OPTION,
  SPA_SIGNED_PENDING_OPTION,
  SPA_SIGNED_OPTION,
  SPA_RECEIVED_OPTION,
  DEVELOPER_SIGNED_OPTION,
  LAWYER_COLLECTED_OPTION,
  SOLD_OPTION,
  DEVELOPER_RECEIVED_OPTION,
  ...LAWYER_LA_STATUSES,
];

export const getLawyerCaseStatuses = (caseType) => {
  switch (caseType) {
    case TYPE_CASE_SPA:
      return LAWYER_SPA_STATUSES;
    case TYPE_CASE_LA:
      return LAWYER_LA_STATUSES;
    default:
      return LAWYER_ALL_STATUSES;
  }
};

// Secondary SPA Lawyer
export const LAWYER_STATUS_ACTIVE = 'active';
export const LAWYER_STATUS_CANCELLED = 'cancelled';
export const REP_TYPE_DEVELOPER = 'developer';
export const REP_TYPE_PURCHASER = 'purchaser';

export const SPA_LAWYER_REP_OPTIONS = [
  { text: 'Developer', value: REP_TYPE_DEVELOPER },
  { text: 'Purchaser', value: REP_TYPE_PURCHASER },
];



// WEBPACK FOOTER //
// ./src/constants/lawyerCaseStatuses.js